import {PositionInLineup} from 'helpers/lineup-helper';
import BaseLineup from 'services/sports/default/base-lineup';

export default class Lineup extends BaseLineup {
    setPlayersByColumns({incomingValues: {team}}) {
        return PositionInLineup.set.inDependenceOnPositionName(team, function (player) {
            player.positionInLineup = 'Driver';
        });
    }
}
